import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, Phone, Mail, ArrowLeft } from "lucide-react";
import { useEffect } from "react";

const CONVERSION_KEY = "mb_offerte_conversion_fired";

export default function ThankYou() {
  const location = useLocation();

  useEffect(() => {
    // Google Ads conversie "Offerte aanvragen": alleen afvuren na een
    // succesvol verzonden formulier, maximaal één keer per sessie.
    if (typeof window === "undefined" || !window.gtag) return;
    if (!location.state?.submitted) return;
    if (sessionStorage.getItem(CONVERSION_KEY)) return;
    sessionStorage.setItem(CONVERSION_KEY, "1");
    window.gtag("event", "conversion", {
      send_to: "AW-18196015802/ipjaCLzD9uwcELrVxORD",
      value: 1.0,
      currency: "EUR",
    });
  }, [location.state]);

  return (
    <div
      data-testid="thank-you-page"
      className="min-h-screen bg-[#F5F7FB] flex items-center justify-center px-5 py-20"
    >
      <div className="w-full max-w-2xl bg-white border border-[#E5E7EB] p-10 md:p-16 text-center">
        <div className="w-20 h-20 mx-auto bg-[#E9F0FB] flex items-center justify-center">
          <CheckCircle2 className="text-[#1E5BC6]" size={44} strokeWidth={1.5} />
        </div>

        <h1 className="mt-8 text-4xl md:text-5xl text-[#0A0A0A] uppercase tracking-tight">
          Dank u wel.
        </h1>
        <div className="brand-rule mx-auto mt-5" />

        <p className="mt-6 text-lg text-[#5A5A5A] max-w-md mx-auto leading-relaxed">
          Uw aanvraag is succesvol verstuurd. Een van onze adviseurs neemt
          binnen één werkdag contact met u op om een gratis adviesgesprek in te
          plannen.
        </p>

        <div className="mt-10 grid sm:grid-cols-2 gap-4 max-w-md mx-auto">
          <a
            href="tel:+31687445044"
            data-testid="thankyou-call"
            className="btn-primary-mb px-6 py-4 text-xs inline-flex items-center justify-center gap-2"
          >
            <Phone size={16} />
            Bel direct
          </a>
          <a
            href="mailto:info@master-bathrooms.nl"
            data-testid="thankyou-email"
            className="btn-outline-mb px-6 py-4 text-xs inline-flex items-center justify-center gap-2"
          >
            <Mail size={16} />
            E-mail ons
          </a>
        </div>

        <div className="mt-12 pt-8 border-t border-[#E5E7EB]">
          <Link
            to="/"
            data-testid="thankyou-back"
            className="text-sm text-[#1E5BC6] hover:underline inline-flex items-center gap-2 uppercase tracking-wide font-semibold"
          >
            <ArrowLeft size={14} />
            Terug naar de website
          </Link>
        </div>
      </div>
    </div>
  );
}
